import React from 'react';
import styled from 'styled-components';
import Container from './Container';
import { scrollToSection } from '../../utils/scrollUtils';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <Container>
        <FooterContent>
          <FooterSection>
            <FooterLogo>Christopher Anto</FooterLogo>
            <FooterDescription>
              Senior Product Manager | Sports Tech · Hyperlocal · HealthTech
            </FooterDescription>
          </FooterSection>

          <FooterSection>
            <FooterSectionTitle>Connect</FooterSectionTitle>
            <FooterSocial>
              <SocialLink href="https://www.linkedin.com/in/christopher-anto/" target="_blank" rel="noopener noreferrer">
                LinkedIn
              </SocialLink>
              <SocialLink href="https://github.com/IntergrityTechnologies" target="_blank" rel="noopener noreferrer">
                GitHub
              </SocialLink>
              <SocialLink href="https://x.com/Christofer_Anto" target="_blank" rel="noopener noreferrer">
                X
              </SocialLink>
            </FooterSocial>
          </FooterSection>
        </FooterContent>

        <FooterDivider />

        <FooterBottom>
          <FooterLogoImage src="/images/ca_wave_logo.png" alt="Christopher Anto" />
          <FooterCopyright>
            © {currentYear} Christopher Anto. All rights reserved.
          </FooterCopyright>
        </FooterBottom>
      </Container>
    </FooterContainer>
  );
};

const FooterContainer = styled.footer`
  background-color: ${({ theme }) => theme.colors.backgroundAlt};
  padding: ${({ theme }) => theme.spacing.xxl} 0 ${({ theme }) => theme.spacing.xl};
`;

const FooterContent = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.xxl};
  padding: 0 ${({ theme }) => theme.spacing.md};
  
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 0;
  }
`;

const FooterSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    align-items: center;
  }
`;

const FooterLogo = styled.h2`
  font-size: 1.75rem;
  color: ${({ theme }) => theme.colors.text};
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;

const FooterDescription = styled.p`
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 1rem;
`;

const FooterSectionTitle = styled.h3`
  font-size: 1.25rem;
  color: ${({ theme }) => theme.colors.text};
  margin-bottom: ${({ theme }) => theme.spacing.lg};
`;

const FooterNav = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md};
`;

const FooterNavItem = styled.div`
  color: ${({ theme }) => theme.colors.textSecondary};
  transition: color 0.3s ease;
  cursor: pointer;
  
  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

const FooterSocial = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md};
`;

const SocialLink = styled.a`
  color: ${({ theme }) => theme.colors.textSecondary};
  transition: color 0.3s ease;
  
  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

const FooterDivider = styled.hr`
  border: 0;
  height: 1px;
  background-color: ${({ theme }) => theme.colors.borderColor};
  margin: ${({ theme }) => theme.spacing.xl} 0;
`;

const FooterBottom = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const FooterCopyright = styled.p`
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 0.875rem;
  margin: 0;
`;

const FooterLogoImage = styled.img`
  height: 40px;
  margin-bottom: ${props => props.theme.spacing.md};
`;

export default Footer;
